import { ThemeProvider } from '@emotion/react';
import { Container } from '@mui/material';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { addPersonalDetails } from 'APIs/UserDataApi';
import { useAppSelector } from 'app/hooks';
import Loader from 'components/atoms/loader';
import SmallDropZonecard from 'components/molecules/Card/DropZone/SmallDropZoneCard';
import InputText from 'components/molecules/InputText/InputText';
import { selectAuth } from 'features/auth/authSlice';
import { IUserPersonalData } from 'interfaces/UserData.interface';
import { ChangeEvent, FormEvent, useReducer, useState } from 'react';
import {
  Body,
  colortheme,
  ContentGrid,
  ParaText,
  SubmitButton,
  TitleText,
} from './styles';

export interface IReducerAction {
  payload: {
    dateOfBirth?: Date;
    file?: any;
    text?: string;
  };
  type: string;
}

const reducer = (
  state: IUserPersonalData,
  action: IReducerAction
): IUserPersonalData => {
  const { type, payload } = action;
  const { text, file, dateOfBirth } = payload;
  if (text) {
    switch (type) {
      case 'realName':
        return {
          ...state,
          realName: text,
        };
      case 'city':
        return {
          ...state,
          city: text,
        };
      case 'address':
        return {
          ...state,
          address: text,
        };
      case 'phone':
        return {
          ...state,
          phone: text,
        };
      case 'postalCode':
        return {
          ...state,
          postalCode: text,
        };
      case 'dateOfBirth':
        return {
          ...state,
          dateOfBirth,
        };
      default:
        return state;
    }
  } else if (file) {
    return {
      ...state,
      idPictures: [...state.idPictures, file],
    };
  } else return state;
};

const reducerInitialState: IUserPersonalData = {
  realName: '',
  address: '',
  dateOfBirth: undefined,
  phone: '',
  postalCode: '',
  city: '',
  idPictures: [],
};

const Aboout = () => {
  const undraw_content = require('assets/undraw_content_.png');
  const [state, dispatch] = useReducer(reducer, reducerInitialState);
  const [loading, setLoading] = useState<boolean>(false);
  const [errState, setErrState] = useState<string[]>([]);
  const [successState, setSuccessState] = useState<boolean>(false);
  const authState = useAppSelector(selectAuth);
  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    dispatch({
      payload: {
        dateOfBirth: e.target.valueAsDate ? e.target.valueAsDate : undefined,
        text: e.target.value,
      },
      type: e.target.name,
    });
  };

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (state.idPictures.length === 0) {
      setErrState(['Please provide with atleast 1 ID picture.']);
      return;
    }

    try {
      if (authState.id && authState.username && authState.walletAddress) {
        setLoading(true);
        await addPersonalDetails(
          state,
          authState.id,
          authState.username,
          authState.walletAddress
        );
        setSuccessState(true);
        setErrState([]);
        setLoading(false);
      }
    } catch (error: any) {
      setLoading(false);
      if (error.response.data.message instanceof Array) {
        setErrState(error.response.data.message);
      } else {
        setErrState([error.response.data.message]);
      }
    }
  };
  return (
    <>
      <ThemeProvider theme={colortheme}>
        <Container>
          <Body>
            <form onSubmit={onSubmit}>
              <ContentGrid sx={{ paddingBottom: '10px' }}>
                <TitleText>About You</TitleText>
              </ContentGrid>
              <ContentGrid>
                <ParaText>We'd like to know more about you!</ParaText>
              </ContentGrid>
              <ContentGrid style={{ paddingBottom: '15px' }}>
                <InputText
                  onChange={onChange}
                  initValue={'Your Real Name'}
                  type={'name'}
                  name={'realName'}
                />
              </ContentGrid>
              <ContentGrid style={{ paddingBottom: '15px' }}>
                <InputText
                  onChange={onChange}
                  initValue={'Date of Birth'}
                  type={'date'}
                  name={'dateOfBirth'}
                />{' '}
              </ContentGrid>
              <ContentGrid style={{ paddingBottom: '15px' }}>
                <InputText
                  onChange={onChange}
                  initValue={'Phone number'}
                  type={'phone'}
                  name={'phone'}
                />
              </ContentGrid>
              <ContentGrid style={{ paddingBottom: '15px' }}>
                <InputText
                  onChange={onChange}
                  initValue={'Resident address'}
                  type={'address'}
                  name={'address'}
                />
              </ContentGrid>
              <ContentGrid style={{ paddingBottom: '15px' }}>
                <InputText
                  onChange={onChange}
                  initValue={'Postal code'}
                  type={'postal'}
                  name={'postalCode'}
                />
              </ContentGrid>
              <ContentGrid style={{ paddingBottom: '15px' }}>
                <InputText
                  onChange={onChange}
                  initValue={'City'}
                  type={'city'}
                  name={'city'}
                />
              </ContentGrid>
              <ContentGrid sx={{ paddingTop: '40px' }}>
                <TitleText>Upload identification</TitleText>
              </ContentGrid>
              <ContentGrid sx={{ paddingBottom: '10px' }}>
                <ParaText>
                  To finalise your registration, we need you to upload a picture
                  of you holding your ID.
                </ParaText>
              </ContentGrid>
              <ContentGrid sx={{ justifyContent: 'center', padding: 'unset' }}>
                <img
                  src={undraw_content}
                  alt={'img'}
                  style={{ width: '208px', height: '105px' }}
                />
              </ContentGrid>
              <ContentGrid
                sx={{ display: 'flex', gap: '22px', marginTop: '28px' }}
              >
                <SmallDropZonecard dispatch={dispatch} />
                <SmallDropZonecard dispatch={dispatch} />
                <SmallDropZonecard dispatch={dispatch} />
              </ContentGrid>
              <Typography
                style={{
                  fontSize: '16px',
                  color: '#c1c1c1',
                  marginLeft: '50px',
                  marginTop: '18px',
                  marginBottom: '53px',
                }}
              >
                1 picture required
              </Typography>
              <ContentGrid sx={{ marginX: '20px', height: '65px' }}>
                <SubmitButton text={loading ? <Loader size="2" /> : 'Submit'} />
              </ContentGrid>
            </form>
            <Stack
              sx={{ width: '50%', alignSelf: 'center' }}
              marginTop={5}
              spacing={2}
            >
              {successState && (
                <Alert
                  onClose={() => {
                    setSuccessState(false);
                  }}
                  severity="success"
                >
                  Personal Details have been submitted sucessfully.
                </Alert>
              )}
              {errState.length > 0 &&
                errState.map((err, index) => (
                  <Alert
                    key={index}
                    onClose={() => {
                      setErrState([]);
                    }}
                    severity="error"
                  >
                    {err}
                  </Alert>
                ))}
            </Stack>
          </Body>
        </Container>
      </ThemeProvider>
    </>
  );
};

export default Aboout;
